/* Heritage Gear — inline predictive search for the custom header. Self-contained. */
(function(){
  if (window.__hgPSearch) return; window.__hgPSearch = 1;

  var CSS = [
    '.hgps-panel{position:absolute;left:0;right:0;top:100%;background:var(--hg-paper,#f4f0e7);border-bottom:1px solid var(--hg-line,#e3ddd0);box-shadow:0 20px 40px rgba(13,59,111,.14);z-index:45;padding:22px 4vw 26px;transform:translateY(-8px);opacity:0;visibility:hidden;transition:opacity .2s ease,transform .2s ease;}',
    '.hgps-panel.is-open{opacity:1;visibility:visible;transform:none;}',
    '.hgps-form{display:flex;align-items:center;gap:12px;border-bottom:2px solid var(--hg-primary,#0d3b6f);padding-bottom:10px;max-width:1100px;margin:0 auto;}',
    '.hgps-form svg{width:20px;height:20px;flex:none;color:var(--hg-primary,#0d3b6f);}',
    '.hgps-input{flex:1;border:0;background:none;outline:none;font:400 26px/1 "Bebas Neue",sans-serif;letter-spacing:.02em;color:var(--hg-primary,#0d3b6f);}',
    '.hgps-input::placeholder{color:#9aa7b4;}',
    '.hgps-close{border:0;background:none;color:var(--hg-primary,#0d3b6f);font:12px "DM Mono",monospace;letter-spacing:.1em;text-transform:uppercase;cursor:pointer;}',
    '.hgps-results{max-width:1100px;margin:16px auto 0;display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:14px;max-height:62vh;overflow:auto;}',
    '.hgps-item{display:flex;gap:12px;align-items:center;text-decoration:none;padding:8px;border:1px solid transparent;border-radius:4px;transition:background .15s ease,border-color .15s ease;}',
    '.hgps-item:hover{background:var(--hg-card,#efe9dc);border-color:var(--hg-line,#e3ddd0);}',
    '.hgps-thumb{width:56px;height:56px;flex:none;background:#fff;border:1px solid var(--hg-line,#e3ddd0);border-radius:3px;overflow:hidden;display:grid;place-items:center;}',
    '.hgps-thumb img{width:100%;height:100%;object-fit:contain;}',
    '.hgps-info{display:flex;flex-direction:column;gap:3px;min-width:0;}',
    '.hgps-title{font:12px "DM Mono",monospace;letter-spacing:.03em;color:var(--hg-primary,#0d3b6f);line-height:1.25;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}',
    '.hgps-price{font:12px "DM Mono",monospace;color:var(--hg-oxblood,#7a2e2e);}',
    '.hgps-msg{max-width:1100px;margin:16px auto 0;font:12px "DM Mono",monospace;letter-spacing:.06em;color:#727c83;text-transform:uppercase;}',
    '@media (max-width:560px){.hgps-input{font-size:20px;}.hgps-results{grid-template-columns:1fr 1fr;}}'
  ].join('');

  var panel, input, results, msg, header, debounce, lastQ = null;

  function injectCSS(){ var s = document.createElement('style'); s.textContent = CSS; document.head.appendChild(s); }

  function esc(s){ return (s == null ? '' : String(s)).replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  function buildPanel(){
    header = document.querySelector('header.hgfnh') || document.querySelector('header');
    if (!header) return false;
    if (getComputedStyle(header).position === 'static') { header.style.position = 'relative'; }
    panel = document.createElement('div');
    panel.className = 'hgps-panel';
    panel.setAttribute('role', 'search');
    panel.innerHTML =
      '<form class="hgps-form">' +
        '<svg viewBox="0 0 64 64" fill="none" stroke="currentColor" stroke-width="4"><path d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"/></svg>' +
        '<input type="search" class="hgps-input" name="q" autocomplete="off" placeholder="Search Heritage Gear" aria-label="Search products">' +
        '<button type="button" class="hgps-close" aria-label="Close search">Close</button>' +
      '</form>' +
      '<div class="hgps-msg" hidden></div>' +
      '<div class="hgps-results"></div>';
    header.appendChild(panel);
    input = panel.querySelector('.hgps-input');
    results = panel.querySelector('.hgps-results');
    msg = panel.querySelector('.hgps-msg');
    panel.querySelector('.hgps-close').addEventListener('click', closePanel);
    panel.querySelector('.hgps-form').addEventListener('submit', function(e){
      e.preventDefault();
      var q = input.value.trim();
      if (!q) return;
      window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last';
    });
    input.addEventListener('input', function(){ clearTimeout(debounce); debounce = setTimeout(run, 200); });
    input.addEventListener('keydown', function(e){ if (e.key === 'Escape') closePanel(); });
    return true;
  }

  function openPanel(){
    if (!panel && !buildPanel()) return;
    panel.classList.add('is-open');
    setTimeout(function(){ input.focus(); }, 60);
  }
  function closePanel(){ if (panel) panel.classList.remove('is-open'); }

  function run(){
    var q = input.value.trim();
    if (q === lastQ) return; lastQ = q;
    if (q.length < 2) { results.innerHTML = ''; msg.hidden = true; return; }
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(d){
        if (input.value.trim() !== q) return;
        var prods = (d.resources && d.resources.results && d.resources.results.products) || [];
        if (!prods.length) { results.innerHTML = ''; msg.textContent = 'No matches for "' + q + '"'; msg.hidden = false; return; }
        msg.hidden = true;
        results.innerHTML = prods.map(function(p){
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          var price = (p.price != null && p.price !== '') ? ('$' + p.price) : '';
          return '<a class="hgps-item" href="' + p.url + '">' +
            '<span class="hgps-thumb">' + (img ? '<img loading="lazy" src="' + img + '" alt="">' : '') + '</span>' +
            '<span class="hgps-info"><span class="hgps-title">' + esc(p.title) + '</span>' +
            (price ? '<span class="hgps-price">' + price + '</span>' : '') + '</span>' +
          '</a>';
        }).join('');
      })
      .catch(function(){});
  }

  function bindTrigger(){
    var trig = document.querySelector('header.hgfnh a[aria-label="Search"], a.hgfnh__icon[aria-label="Search"]');
    if (!trig) return false;
    trig.setAttribute('role', 'button');
    trig.addEventListener('click', function(e){
      e.preventDefault();
      if (panel && panel.classList.contains('is-open')) closePanel(); else openPanel();
    });
    return true;
  }

  document.addEventListener('keydown', function(e){ if (e.key === 'Escape') closePanel(); });
  function outside(e){
    if (!panel || !panel.classList.contains('is-open')) return;
    var t = e.target;
    if (t && t.closest && (t.closest('.hgps-panel') || t.closest('a[aria-label="Search"]'))) return;
    closePanel();
  }
  document.addEventListener('mousedown', outside, true);
  document.addEventListener('click', outside, true);

  function boot(){ injectCSS(); bindTrigger(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
})();
